// import React, { Component } from "react";
// import * as echarts from "echarts/dist/echarts.js";
// import "bootstrap/dist/css/bootstrap.css";
// import "./dashboard.css";
// import {
//   getSystemRealTimeData,
//   getSystemLatestData,
//   getSystemBasics,
//   ws_getSystemLatestData,
//   getSystemInfo,
// } from "../services/systemService";

// import { webSocketMode } from "../config.json"; //0: http; 1:websocket

// class LineGraph extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       graphLen: 0,
//       base: new Date(),
//       oneDay: 86400000,
//       date: [],
//       value1: [0],
//       value2: [0],
//       value3: [0],
//       value4: [0],
//       value5: [0],
//       now: new Date(),
//     };
//   }

//   async componentDidMount() {
//     if (this.props.chartDateInitial) {
//       this.setState({
//         date: this.props.chartDateInitial,
//         value1: this.props.chartValue1Initial,
//         value2: this.props.chartValue2Initial,
//         value3: this.props.chartValue3Initial,
//         value4: this.props.chartValue4Initial,
//         value5: this.props.chartValue5Initial,
//       });
//     }

//     this.chart = echarts.init(document.getElementById("graph-area"));
//     //console.log("Tick Number", tickNumber);
//     const tickNumber = 1000;
//     this.timerID = setInterval(() => this.tick(), tickNumber);
//     this.generateGraph();
//   }

//   componentWillUnmount() {
//     clearInterval(this.timerID);
//   }

//   tick() {
//     this.addData(false);
//     this.chart.setOption({
//       yAxis: {
//         max: this.props.maxTemp + 5.0,
//         min: this.props.minTemp - 5.0,
//       },
//       xAxis: {
//         data: this.state.date,
//         axisTick: { show: true },
//         splitLine: { show: true },
//       },
//       series: [
//         {
//           name: `${this.props.chartLegend1}`,
//           data: this.state.value1,
//         },
//         {
//           name: `${this.props.chartLegend2}`,
//           data: this.state.value2,
//         },
//         {
//           name: `${this.props.chartLegend3}`,
//           data: this.state.value3,
//         },
//         {
//           name: `${this.props.chartLegend4}`,
//           data: this.state.value4,
//         },
//         {
//           name: `${this.props.chartLegend5}`,
//           data: this.state.value5,
//         },
//       ],
//     });
//   }

//   addData(shift) {
//     /* this.state.now = [
//       this.state.now.getHours(),
//       this.state.now.getMinutes(),
//       this.state.now.getSeconds(),
//     ].join(":");*/
//     console.log("Date Array in Chart: ", this.state.date);
//     const stringLength = parseInt(this.state.value1.length);
//     const pointsOnChart = parseInt(localStorage.getItem("pointsOnChart"));
//     const delta = stringLength - pointsOnChart;
//     console.log(
//       "String Length | Points on Chart | Delta: ",
//       stringLength,
//       pointsOnChart,
//       delta
//     );
//     console.log("This chart data timestamp:", this.props.dataTimeStamp);
//     //this.state.now = new Date(this.props.dataTimeStamp).getTime();
//     /* this.state.now = [
//       new Date(this.props.dataTimeStamp).getHours(),
//       new Date(this.props.dataTimeStamp).getMinutes(),
//       new Date(this.props.dataTimeStamp).getSeconds(),
//     ].join(":");*/
//     //console.log("This State Now: ", this.state.now);
//     //if (this.state.now)
//     //this.state.date.push(this.state.now /*props.dataTimeStamp*/);
//     if (this.props.playPause) this.state.date.push(this.state.now);
//     /*if (this.props.chartDateInitial) {
//         this.state.value1.push(this.props.chartValue1);
//         this.state.value2.push(this.props.chartValue2);
//         this.state.value3.push(this.props.chartValue3);
//         this.state.value4.push(this.props.chartValue4);
//         this.state.value5.push(this.props.chartValue5);
//       }*/
//     // }
//     if (this.props.chartDateInitial) {
//       this.state.value1.push(this.props.chartValue1);
//       this.state.value2.push(this.props.chartValue2);
//       this.state.value3.push(this.props.chartValue3);
//       this.state.value4.push(this.props.chartValue4);
//       this.state.value5.push(this.props.chartValue5);
//     }
//     /* if (delta === 1) {
//       this.state.now = [
//         this.state.now.getHours(),
//         this.state.now.getMinutes(),
//         this.state.now.getSeconds(),
//       ].join(":");
//       this.state.date.shift();
//       this.state.value1.shift();
//       this.state.value2.shift();
//       this.state.value3.shift();
//       this.state.value4.shift();
//       this.state.value5.shift();
//       this.state.now = new Date();
//     } else if (delta >= 1) {
//       for (let i = 0; i < delta; i++) {
//         this.state.now = [
//           this.state.now.getHours(),
//           this.state.now.getMinutes(),
//           this.state.now.getSeconds(),
//         ].join(":");
//         this.state.date.shift();
//         this.state.value1.shift();
//         this.state.value2.shift();
//         this.state.value3.shift();
//         this.state.value4.shift();
//         this.state.value5.shift();
//         this.state.now = new Date();
//       }
//     }*/
//     if (delta > 0 && this.props.modeBox === "Real-time") {
//       console.log(
//         "........................Shifting  .........................."
//       );
//       const dateLength = this.state.date.length;
//       const dataLength = this.state.value1.length;
//       console.log("Chart Data Length: ", dateLength, dataLength);
//       this.state.date.shift();
//       this.state.value1.shift();
//       this.state.value2.shift();
//       this.state.value3.shift();
//       this.state.value4.shift();
//       this.state.value5.shift();
//       this.state.now = new Date();
//       this.state.now = [
//         this.state.now.getHours(),
//         this.state.now.getMinutes(),
//         this.state.now.getSeconds(),
//       ].join(":");
//       /* this.state.date = [
//         this.state.date.getHours(),
//         this.state.date.getMinutes(),
//         this.state.date.getSeconds(),
//       ].join(":");*/
//     }
//   }

//   generateGraph() {
//     var option = {
//       legend: {
//         type: "scroll",
//         data: [
//           `${this.props.chartLegend1}`,
//           `${this.props.chartLegend2}`,
//           `${this.props.chartLegend3}`,
//           `${this.props.chartLegend4}`,
//           `${this.props.chartLegend5}`,
//         ],
//         center: "50%",
//         top: "0%",
//         orient: "horizontal",
//         align: "auto",
//         padding: 3,
//         textStyle: {
//           fontStyle: "normal",
//           fontSize: 10,
//           fontWeight: "bold",
//           color: "grey",
//         },
//         backgroundColor: "transparent",
//         borderColor: "#ffffff",
//         borderWidth: 1,
//         boarderRadius: 0,
//       },
//       xAxis: {
//         name: "",
//         nameLocation: "end",
//         type: "category",
//         nameTextStyle: {
//           fontStyle: "normal",
//           fontSize: 16,
//           fontWeight: "bolder",
//           color: "green",
//         },
//         axisLabel: {
//           fontStyle: "normal",
//           fontSize: 8,
//           fontWeight: "normal",
//           color: "orange",
//         },
//         boundaryGap: false,
//         data: this.state.date,
//       },
//       yAxis: {
//         show: false,
//         name: "Power (Watts)",
//         nameLocation: "end",
//         boundaryGap: [0, "10%"],
//         type: "value",
//         nameTextStyle: {
//           fontStyle:
//             "normal" /*'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif'*/,
//           fontSize: 16,
//           fontWeight: "bolder",
//           color: "green",
//         },
//         axisLabel: {
//           fontStyle: "normal",
//           fontSize: 10,
//           fontWeight: "bold",
//           color: "green",
//         },
//       },
//       dataZoom: [
//         {
//           type: "slider",
//           show: true,
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//         {
//           type: "inside",
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//       ],
//       series: [
//         {
//           name: "PV Power",
//           type: "line",
//           symbol: "none",
//           color: "orange",
//           smooth: 0.25,
//           /* areaStyle: {
//             normal: {
//               color: "orange",
//             },
//           },*/
//           data: this.state.value1,
//         },
//         {
//           name: "Battery Power",
//           type: "line",
//           symbol: "none",
//           color: "DodgerBlue",
//           smooth: 0.25,
//           /*areaStyle: {
//             normal: { color: "DodgerBlue" },
//           },*/
//           data: this.state.value2,
//         },
//         {
//           name: "Grid Power",
//           type: "line",
//           symbol: "none",
//           color: "magenta",
//           smooth: 0.25,
//           data: this.state.value3,
//         },
//         {
//           name: "Building Power",
//           type: "line",
//           symbol: "none",
//           color: "green",
//           smooth: 0.25,
//           data: this.state.value4,
//           /*label: {
//             show: true,
//             value: "kW"
//           }*/
//         },
//         {
//           name: "Room Temp.",
//           type: "line",
//           symbol: "none",
//           color: "red",
//           smooth: 0.25,
//           data: this.state.value5,
//           /*label: {
//             show: true,
//             value: "kW"
//           }*/
//         },
//       ],
//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           animation: false,
//           type: "cross",
//           label: {
//             backgroundColor: "#6a7985",
//             precision: "2",
//           },
//         },
//       },
//     };

//     this.chart.setOption(option);
//   }

//   render() {
//     return <div id="graph-area" />;
//   }
// }
// export default LineGraph;

// import React, { Component } from "react";
// import * as echarts from "echarts/dist/echarts.js";
// import "bootstrap/dist/css/bootstrap.css";
// import "./dashboard.css";
// import {
//   getSystemRealTimeData,
//   getSystemLatestData,
//   getSystemBasics,
//   ws_getSystemLatestData,
//   getSystemInfo,
// } from "../services/systemService";

// import { webSocketMode } from "../config.json"; //0: http; 1:websocket

// class LineGraph extends Component {
//   constructor(props) {
//     super(props);
//     this.chart = null;
//     this.timerID = null;

//     this.state = {
//       graphLen: 0,
//       base: new Date(),
//       oneDay: 86400000,
//       date: [],
//       value1: [0],
//       value2: [0],
//       value3: [0],
//       value4: [0],
//       value5: [0],
//       now: new Date(),
//     };

//     // explicit palette (keeps original colors)
//     this.defaultColors = [
//       "orange", // PV Power
//       "DodgerBlue", // Battery Power
//       "magenta", // Grid Power
//       "green", // Building Power
//       "red", // Room Temp
//     ];
//   }

//   async componentDidMount() {
//     if (this.props.chartDateInitial) {
//       this.setState(
//         {
//           date: this.props.chartDateInitial,
//           value1: this.props.chartValue1Initial || [],
//           value2: this.props.chartValue2Initial || [],
//           value3: this.props.chartValue3Initial || [],
//           value4: this.props.chartValue4Initial || [],
//           value5: this.props.chartValue5Initial || [],
//         },
//         () => {
//           this.chart = echarts.init(document.getElementById("graph-area"));
//           this.generateGraph();
//         }
//       );
//     } else {
//       this.chart = echarts.init(document.getElementById("graph-area"));
//       this.generateGraph();
//     }

//     const tickNumber = 1000;
//     this.timerID = setInterval(() => this.tick(), tickNumber);
//   }

//   componentDidUpdate(prevProps) {
//     if (
//       prevProps.chartDateInitial !== this.props.chartDateInitial ||
//       prevProps.chartValue1Initial !== this.props.chartValue1Initial ||
//       prevProps.chartValue2Initial !== this.props.chartValue2Initial ||
//       prevProps.chartValue3Initial !== this.props.chartValue3Initial ||
//       prevProps.chartValue4Initial !== this.props.chartValue4Initial ||
//       prevProps.chartValue5Initial !== this.props.chartValue5Initial
//     ) {
//       this.setState(
//         {
//           date: this.props.chartDateInitial || [],
//           value1: this.props.chartValue1Initial || [],
//           value2: this.props.chartValue2Initial || [],
//           value3: this.props.chartValue3Initial || [],
//           value4: this.props.chartValue4Initial || [],
//           value5: this.props.chartValue5Initial || [],
//         },
//         () => {
//           this.generateGraph(true);
//         }
//       );
//     }

//     if (
//       prevProps.chartValue1 !== this.props.chartValue1 ||
//       prevProps.chartValue2 !== this.props.chartValue2 ||
//       prevProps.chartValue3 !== this.props.chartValue3 ||
//       prevProps.chartValue4 !== this.props.chartValue4 ||
//       prevProps.chartValue5 !== this.props.chartValue5 ||
//       prevProps.maxTemp !== this.props.maxTemp ||
//       prevProps.minTemp !== this.props.minTemp
//     ) {
//       if (this.props.chartDateInitial) {
//         this.setState(
//           (prev) => {
//             const newValue1 = prev.value1.concat(this.props.chartValue1);
//             const newValue2 = prev.value2.concat(this.props.chartValue2);
//             const newValue3 = prev.value3.concat(this.props.chartValue3);
//             const newValue4 = prev.value4.concat(this.props.chartValue4);
//             const newValue5 = prev.value5.concat(this.props.chartValue5);
//             const newDate = this.props.playPause
//               ? prev.date.concat(prev.now)
//               : prev.date;

//             const pointsOnChart = parseInt(
//               localStorage.getItem("pointsOnChart")
//             );
//             const delta = newValue1.length - pointsOnChart;

//             if (delta > 0 && this.props.modeBox === "Real-time") {
//               return {
//                 date: newDate.slice(delta),
//                 value1: newValue1.slice(delta),
//                 value2: newValue2.slice(delta),
//                 value3: newValue3.slice(delta),
//                 value4: newValue4.slice(delta),
//                 value5: newValue5.slice(delta),
//               };
//             }

//             return {
//               date: newDate,
//               value1: newValue1,
//               value2: newValue2,
//               value3: newValue3,
//               value4: newValue4,
//               value5: newValue5,
//             };
//           },
//           () => {
//             this.updateSeriesOnly();
//           }
//         );
//       } else {
//         this.updateSeriesOnly();
//       }
//     }
//   }

//   componentWillUnmount() {
//     clearInterval(this.timerID);
//     if (this.chart) {
//       this.chart.dispose();
//       this.chart = null;
//     }
//   }

//   generateGraph(replace = false) {
//     const pointsOnChart = Number(localStorage.getItem("pointsOnChart") || 0);

//     const option = {
//       color: this.defaultColors,

//       legend: {
//         type: "scroll",
//         data: [
//           `${this.props.chartLegend1 || "PV Power"}`,
//           `${this.props.chartLegend2 || "Battery Power"}`,
//           `${this.props.chartLegend3 || "Grid Power"}`,
//           `${this.props.chartLegend4 || "Building Power"}`,
//           `${this.props.chartLegend5 || "Room Temp."}`,
//         ],
//         center: "50%",
//         top: "0%",
//         orient: "horizontal",
//         align: "auto",
//         padding: 3,
//         textStyle: {
//           fontStyle: "normal",
//           fontSize: 10,
//           fontWeight: "bold",
//           color: "grey",
//         },
//         backgroundColor: "transparent",
//         borderColor: "#ffffff",
//         borderWidth: 1,
//         boarderRadius: 0,
//       },

//       grid: {
//         top: 30,
//         bottom: 60,
//         // left: "8%",
//         // right: "8%",
//       },

//       xAxis: {
//         name: "",
//         nameLocation: "end",
//         type: "category",
//         // axisTick: { show: true },
//         // splitLine: { show: true },
//         axisLabel: {
//           interval: "auto",
//           fontStyle: "normal",
//           fontSize: 8,
//           fontWeight: "normal",
//           color: "orange",
//         },
//         boundaryGap: false,
//         data: this.state.date,
//       },

//       yAxis: {
//         // show: false,
//         axisLabel: {
//           fontStyle: "normal",
//           fontSize: 8,
//           fontWeight: "normal",
//           color: "orange",
//         },
//       },

//       dataZoom: [
//         {
//           type: "slider",
//           show: true,
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//         {
//           type: "inside",
//           xAxisIndex: [0],
//           start: 1,
//           end: 100,
//         },
//       ],

//       series: [
//         {
//           name: `${this.props.chartLegend1 || "PV Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           color: "orange",
//           smooth: 0.25,
//           data: this.state.value1,
//         },
//         {
//           name: `${this.props.chartLegend2 || "Battery Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           color: "DodgerBlue",
//           smooth: 0.25,
//           data: this.state.value2,
//         },
//         {
//           name: `${this.props.chartLegend3 || "Grid Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           color: "magenta",
//           smooth: 0.25,
//           data: this.state.value3,
//         },
//         {
//           name: `${this.props.chartLegend4 || "Building Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           color: "green",
//           smooth: 0.25,
//           data: this.state.value4,
//         },
//         {
//           name: `${this.props.chartLegend5 || "Room Temp."}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           color: "red",
//           smooth: 0.25,
//           data: this.state.value5,
//         },
//       ],

//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           animation: false,
//           type: "cross",
//           label: {
//             backgroundColor: "#6a7985",
//             precision: "2",
//           },
//         },
//       },
//     };

//     if (!this.chart)
//       this.chart = echarts.init(document.getElementById("graph-area"));

//     if (replace) {
//       this.chart.setOption(option, true);
//     } else {
//       this.chart.setOption(option);
//     }
//   }

//   updateSeriesOnly() {
//     if (!this.chart) return;
//     this.chart.setOption({
//       yAxis: {
//         max: this.props.maxTemp + 5.0,
//         min: this.props.minTemp - 5.0,
//       },
//       series: [
//         {
//           name: `${this.props.chartLegend1 || "PV Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           data: this.state.value1,
//         },
//         {
//           name: `${this.props.chartLegend2 || "Battery Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           data: this.state.value2,
//         },
//         {
//           name: `${this.props.chartLegend3 || "Grid Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           data: this.state.value3,
//         },
//         {
//           name: `${this.props.chartLegend4 || "Building Power"}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           data: this.state.value4,
//         },
//         {
//           name: `${this.props.chartLegend5 || "Room Temp."}`,
//           type: "line",
//           symbol: "none",
//           showSymbol: false,
//           lineStyle: { width: 2 },
//           data: this.state.value5,
//         },
//       ],
//     });
//   }

//   tick() {
//     if (this.props.playPause) {
//       const now = new Date();
//       const hh = String(now.getHours()).padStart(2, "0");
//       const mm = String(now.getMinutes()).padStart(2, "0");
//       const ss = String(now.getSeconds()).padStart(2, "0");
//       const nowStr = `${hh}:${mm}:${ss}`;

//       this.setState(
//         (prev) => {
//           const newDate = prev.date.concat(nowStr);
//           const newValue1 = prev.value1.concat(this.props.chartValue1);
//           const newValue2 = prev.value2.concat(this.props.chartValue2);
//           const newValue3 = prev.value3.concat(this.props.chartValue3);
//           const newValue4 = prev.value4.concat(this.props.chartValue4);
//           const newValue5 = prev.value5.concat(this.props.chartValue5);

//           const pointsOnChart = parseInt(localStorage.getItem("pointsOnChart"));
//           const delta = newValue1.length - pointsOnChart;

//           if (delta > 0 && this.props.modeBox === "Real-time") {
//             return {
//               date: newDate.slice(delta),
//               value1: newValue1.slice(delta),
//               value2: newValue2.slice(delta),
//               value3: newValue3.slice(delta),
//               value4: newValue4.slice(delta),
//               value5: newValue5.slice(delta),
//               now,
//             };
//           }

//           return {
//             date: newDate,
//             value1: newValue1,
//             value2: newValue2,
//             value3: newValue3,
//             value4: newValue4,
//             value5: newValue5,
//             now,
//           };
//         },
//         () => {
//           if (!this.chart) return;
//           this.chart.setOption({
//             xAxis: {
//               axisLabel: { interval: "auto" },
//               data: this.state.date,
//             },
//             yAxis: {
//               max: this.props.maxTemp + 5.0,
//               min: this.props.minTemp - 5.0,
//             },
//             series: [
//               {
//                 name: `${this.props.chartLegend1 || "PV Power"}`,
//                 type: "line",
//                 symbol: "none",
//                 showSymbol: false,
//                 lineStyle: { width: 2 },
//                 data: this.state.value1,
//               },
//               {
//                 name: `${this.props.chartLegend2 || "Battery Power"}`,
//                 type: "line",
//                 symbol: "none",
//                 showSymbol: false,
//                 lineStyle: { width: 2 },
//                 data: this.state.value2,
//               },
//               {
//                 name: `${this.props.chartLegend3 || "Grid Power"}`,
//                 type: "line",
//                 symbol: "none",
//                 showSymbol: false,
//                 lineStyle: { width: 2 },
//                 data: this.state.value3,
//               },
//               {
//                 name: `${this.props.chartLegend4 || "Building Power"}`,
//                 type: "line",
//                 symbol: "none",
//                 showSymbol: false,
//                 lineStyle: { width: 2 },
//                 data: this.state.value4,
//               },
//               {
//                 name: `${this.props.chartLegend5 || "Room Temp."}`,
//                 type: "line",
//                 symbol: "none",
//                 showSymbol: false,
//                 lineStyle: { width: 2 },
//                 data: this.state.value5,
//               },
//             ],
//           });
//         }
//       );
//     } else {
//       this.updateSeriesOnly();
//     }
//   }

//   render() {
//     return (
//       <div
//         id="graph-area"
//         // style={{ width: "100%", height: "300px" }}
//       />
//     );
//   }
// }

// export default LineGraph;

import React, { Component } from "react";
import * as echarts from "echarts/dist/echarts.js";
import "bootstrap/dist/css/bootstrap.css";
import "./dashboard.css";
import { ThemeProvider } from "styled-components";

class LineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      graphLen: 0,
      base: new Date(),
      oneDay: 86400000,
      date: [],
      value1: [0],
      value2: [0],
      value3: [0],
      value4: [0],
      value5: [0],
      now: new Date(),
    };
  }

  async componentDidMount() {
    if (this.props.chartDateInitial) {
      this.setState({
        date: this.props.chartDateInitial,
        value1: this.props.chartValue1Initial,
        value2: this.props.chartValue2Initial,
        value3: this.props.chartValue3Initial,
        value4: this.props.chartValue4Initial,
        value5: this.props.chartValue5Initial,
      });
    }

    this.chart = echarts.init(document.getElementById("graph-area"));
    const tickNumber = 1000;
    this.timerID = setInterval(() => this.tick(), tickNumber);
    this.generateGraph();
    // this.setState({ playPause: this.props.playPause });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.chart) return;

    // Only update data — never override legend or series definitions
    this.chart.setOption({
      xAxis: { data: this.state.date },
      series: [
        { name: this.props.chartLegend1, data: this.state.value1 },
        { name: this.props.chartLegend2, data: this.state.value2 },
        { name: this.props.chartLegend3, data: this.state.value3 },
        { name: this.props.chartLegend4, data: this.state.value4 },
        { name: this.props.chartLegend5, data: this.state.value5 },
      ],
    });
  }

  // componentDidUpdate() {
  //   if (!this.chart) return;

  //   this.chart.setOption({
  //     xAxis: { data: this.state.date },
  //     series: [
  //       { name: this.props.chartLegend1, data: this.state.value1 },
  //       { name: this.props.chartLegend2, data: this.state.value2 },
  //       { name: this.props.chartLegend3, data: this.state.value3 },
  //       { name: this.props.chartLegend4, data: this.state.value4 },
  //       { name: this.props.chartLegend5, data: this.state.value5 },
  //     ],
  //   });
  // }

  // componentDidUpdate(prevProps) {
  //   if (!this.chart) return;

  //   if (
  //     this.props.modeBox === "Real-time" &&
  //     prevProps.modeBox !== "Real-time"
  //   ) {
  //     this.resetRealtimeWindow();
  //     return;
  //   }

  //   this.chart.setOption({
  //     xAxis: { data: this.state.date },
  //     series: [
  //       { name: this.props.chartLegend1, data: this.state.value1 },
  //       { name: this.props.chartLegend2, data: this.state.value2 },
  //       { name: this.props.chartLegend3, data: this.state.value3 },
  //       { name: this.props.chartLegend4, data: this.state.value4 },
  //       { name: this.props.chartLegend5, data: this.state.value5 },
  //     ],
  //   });
  // }

  resetRealtimeWindow() {
    this.setState({
      date: [],
      value1: [],
      value2: [],
      value3: [],
      value4: [],
      value5: [],
    });

    this.chart.setOption({
      xAxis: { data: [] },
      series: [
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
        { data: [] },
      ],
    });
    // this.props.playPause = true;
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    // this.addData(false);
    this.addData();
    // this.chart.setOption({
    //   yAxis: {
    //     max: this.props.maxTemp + 5.0,
    //     min: this.props.minTemp - 5.0,
    //   },
    //   xAxis: {
    //     data: this.state.date,
    //     axisTick: { show: true },
    //     splitLine: { show: true },
    //   },
    //   series: [
    //     { name: `${this.props.chartLegend1}`, data: this.state.value1 },
    //     { name: `${this.props.chartLegend2}`, data: this.state.value2 },
    //     { name: `${this.props.chartLegend3}`, data: this.state.value3 },
    //     { name: `${this.props.chartLegend4}`, data: this.state.value4 },
    //     { name: `${this.props.chartLegend5}`, data: this.state.value5 },
    //   ],
    // });
  }

  addData() {
    const raw = localStorage.getItem("pointsOnChart");
    const pointsOnChart = Number(raw) || 50; // safe default

    const ts = this.props.dataTimeStamp;
    let timeSource = new Date(ts);
    if (isNaN(timeSource.getTime())) timeSource = new Date();

    const formattedTime = [
      timeSource.getHours().toString().padStart(2, "0"),
      timeSource.getMinutes().toString().padStart(2, "0"),
      timeSource.getSeconds().toString().padStart(2, "0"),
    ].join(":");

    if (!this.props.playPause) return;

    this.setState((prev) => {
      const date = [...prev.date, formattedTime];
      const v1 = [...prev.value1, this.props.chartValue1];
      const v2 = [...prev.value2, this.props.chartValue2];
      const v3 = [...prev.value3, this.props.chartValue3];
      const v4 = [...prev.value4, this.props.chartValue4];
      const v5 = [...prev.value5, this.props.chartValue5];

      while (
        date.length > pointsOnChart &&
        this.props.modeBox === "Real-time"
      ) {
        date.shift();
        v1.shift();
        v2.shift();
        v3.shift();
        v4.shift();
        v5.shift();
      }

      return {
        date,
        value1: v1,
        value2: v2,
        value3: v3,
        value4: v4,
        value5: v5,
      };
    });
  }

  // addData() {
  //   if (!this.props.playPause) return;

  //   const ts = this.props.dataTimeStamp;
  //   const timeValue = isNaN(new Date(ts).getTime())
  //     ? Date.now()
  //     : new Date(ts).getTime();

  //   this.setState((prev) => {
  //     const date = [...prev.date, timeValue];
  //     const v1 = [...prev.value1, this.props.chartValue1];
  //     const v2 = [...prev.value2, this.props.chartValue2];
  //     const v3 = [...prev.value3, this.props.chartValue3];
  //     const v4 = [...prev.value4, this.props.chartValue4];
  //     const v5 = [...prev.value5, this.props.chartValue5];

  //     const pointsOnChart = Number(localStorage.getItem("pointsOnChart")) || 50;

  //     while (
  //       date.length > pointsOnChart &&
  //       this.props.modeBox === "Real-time"
  //     ) {
  //       date.shift();
  //       v1.shift();
  //       v2.shift();
  //       v3.shift();
  //       v4.shift();
  //       v5.shift();
  //     }

  //     return {
  //       date,
  //       value1: v1,
  //       value2: v2,
  //       value3: v3,
  //       value4: v4,
  //       value5: v5,
  //     };
  //   });
  // }

  generateGraph() {
    var option = {
      legend: {
        type: "scroll",
        data: [
          `${this.props.chartLegend1}`,
          `${this.props.chartLegend2}`,
          `${this.props.chartLegend3}`,
          `${this.props.chartLegend4}`,
          `${this.props.chartLegend5}`,
        ],
        center: "50%",
        top: "0%",
        orient: "horizontal",
        align: "auto",
        padding: 3,
        textStyle: {
          fontStyle: "normal",
          fontSize: 10,
          fontWeight: "bold",
          color: "grey",
        },
        backgroundColor: "transparent",
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#e0e0e0",
            type: "solid", // or "dashed"
            width: 1,
          },
        },
        data: this.state.date,
      },
      yAxis: {
        show: true,
        type: "value",
        axisLabel: {
          fontStyle: "normal",
          fontSize: 8,
          fontWeight: "normal",
          color: "orange",
        },
      },
      dataZoom: [
        {
          type: "slider",
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
          height: 20,
        },
        { type: "inside", xAxisIndex: [0], start: 1, end: 100 },
        {
          type: "inside",
          yAxisIndex: 0,
          filterMode: "none",
        },
        {
          type: "slider",
          yAxisIndex: 0,
          right: "8%",
          width: 20,
        },
      ],
      series: [
        {
          name: this.props.chartLegend1, // "PV Power",
          type: "line",
          symbol: "none",
          color: "orange",
          smooth: 0.25,
          data: this.state.value1,
        },
        {
          name: this.props.chartLegend2, // "Battery Power",
          type: "line",
          symbol: "none",
          color: "dodgerBlue",
          smooth: 0.25,
          data: this.state.value2,
        },
        {
          name: this.props.chartLegend3, // "Grid Power",
          type: "line",
          symbol: "none",
          color: "magenta",
          smooth: 0.25,
          data: this.state.value3,
        },
        {
          name: this.props.chartLegend4, // "Building Power",
          type: "line",
          symbol: "none",
          color: "green",
          smooth: 0.25,
          data: this.state.value4,
        },
        {
          name: this.props.chartLegend5, // "Room Temp.",
          type: "line",
          symbol: "none",
          color: "red",
          smooth: 0.25,
          data: this.state.value5,
        },
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          animation: false,
          type: "cross",
          label: { backgroundColor: "#6a7985", precision: "2" },
        },
        hideDelay: 2000,
      },
    };
    // this.chart.clear();

    this.chart.setOption(option);
    // this.resetRealtimeWindow();
    // return;
  }

  render() {
    return <div id="graph-area" />;
  }
}

export default LineGraph;
